// Constants
import PDC from "components/Stacker/constants/ProductDetailPageConstants"

// Config
import PDCS from "components/Stacker/config/ProductDetailsConfig"

// Utils
import ApiUtils from "components/Stacker/api"

import { getDY_SR } from "stackerConfig"

export const getpdpPromo = (promoPath, pid) => (dispatch, getState) => {
  Promise.all(
    promoPath.map((promo) => {
      return ApiUtils.makeAjaxRequest({
        url: `${promo}.html`,
        type: "html",
      })
    })
  )
    .then((promos) => {
      dispatch({
        type: PDC.PDP_PROMO_SUCCEED,
        payload: { pid, promos },
      })
    })
    .catch((err) => {
      dispatch({
        type: PDC.PDP_PROMO_FAILED,
        payload: {
          pid,
          err,
        },
      })
    })
}

export const getProductDetails =
  ({ args, retailerId }) =>
  (dispatch, getState) => {
    const preloadedResponse = getDY_SR().data ? getDY_SR().data.pdp : null
    if (preloadedResponse && Object.keys(preloadedResponse).length) {
      delete getDY_SR().data.pdp
      dispatch({
        type: PDC.PRODUCT_DETAIL_SUCCEED,
        payload: { res: { ...preloadedResponse }, ...args },
      })
    } else {
      ApiUtils.makeAjaxRequest(
        {
          // url: '/.api.product.detail.render.json',
          //TODO: probably get the current retailer from the stacker context
          url: `/v1/retailer/${retailerId}/product/${args.productId}`,
          queryParams: {
            pid: args.productId, // Base ProductID
            baseStore: args.baseStore,
          },
        },
        (res) => {
          let promos = []
          if (res.promoPath && res.promoPath.length > 0) {
            promos = promos.concat(res.promoPath)
          }
          if (res.collectionPromoPath && res.collectionPromoPath.length) {
            promos = [...promos, res.collectionPromoPath]
          }
          dispatch(getpdpPromo(promos, args.productId))
          dispatch({
            type: PDC.PRODUCT_DETAIL_SUCCEED,
            payload: { res, ...args, isSoftReload: true },
          })
          if (args.callback) {
            args.callback(res)
          }
        },
        (err) => {
          dispatch({
            type: PDC.PRODUCT_DETAIL_FAILED,
            payload: {
              productId: args,
              err,
            },
          })
        }
      )
    }
  }

export const getPriceAndInventory =
  (args, retailerId) => (dispatch, getState) => {
    ApiUtils.makeAjaxRequest(
      {
        // url: '/.api.product.priceAndInventory.json',
        url: `/v1/retailer/${retailerId}/product/${args.productId}/price-and-inventory`,
        queryParams: {
          productId: args.productId, // Current Product Code
          productType: args.productType,
          baseStore: args.baseStore,
        },
      },
      (res) => {
        dispatch({
          type: PDC.PRODUCT_INVENTORY_SUCCEED,
          payload: {
            res: res.list.DyProductData,
            ...args,
          },
        })
      },
      (err) => {
        dispatch({
          type: PDC.PRODUCT_INVENTORY_FAILED,
          payload: {
            pid: args.pid,
            err,
          },
        })
      }
    )
  }

export const selectQuickViewProduct = (pid, url) => {
  return {
    type: PDC.QUICK_VIEW_SELECT,
    payload: { pid: pid.toUpperCase(), url },
  }
}

export const clearQuickViewProduct = () => {
  return {
    type: PDC.QUICK_VIEW_CLEAR,
  }
}

export const setSelectedSize = (options) => {
  return {
    type: PDC.SET_SELECTED_SIZE,
    payload: options,
  }
}

export const setSizeSelectionError = (options) => {
  return {
    type: PDC.PDP_SET_SIZE_SELECTION_ERROR,
    payload: options,
  }
}

export const setSelectedGiftCardAmount = (pid, amountObj) => {
  return {
    type: PDC.SET_SELECTED_GIFT_AMOUNT,
    payload: { pid, amountObj },
  }
}

export const toggleProductDetails = (pid) => {
  return {
    type: PDC.TOGGLE_PRODUCT_DETAILS,
    payload: { pid },
  }
}

export const metalSelected = (pid, url) => {
  return {
    type: PDC.METAL_SELECTED,
    payload: { pid, url },
  }
}

export const resetSizeSelectionError = (options) => {
  return {
    type: PDC.PDP_RESET_SIZE_SELECTION_ERROR,
    payload: options,
  }
}

export const setSizeChartView = (view) => {
  return {
    type: PDC.PDP_SET_SIZE_CHART_VIEW,
    payload: view,
  }
}

export const submitSizeKitOrder = (formData) => (dispatch, getState) => {
  ApiUtils.makeAjaxRequest(
    {
      url: "/.api.ringSizeKit.html",
      method: ApiUtils.METHOD_POST,
      payload: formData,
    },
    (res) => {
      if (
        res.status === ApiUtils.RESPONSE_SUCCESS &&
        res.Registered === "true"
      ) {
        dispatch({
          type: PDC.SIZE_KIT_ORDER_SUCCESS,
        })
      } else {
        dispatch({
          type: PDC.SIZE_KIT_ORDER_ERROR,
          payload: { errorMessage: res.errorMessage },
        })
      }
    },
    (err) => {
      dispatch({
        type: PDC.SIZE_KIT_ORDER_ERROR,
        payload: { errorMessage: err.errorMessage ? err.errorMessage : "" },
      })
    }
  )
}

export const resetSizeKitOrderForm = () => (dispatch) => {
  dispatch({
    type: PDC.SIZE_KIT_FORM_RESET,
  })
}

export const submitNotifyUser = (formData) => (dispatch) => {
  ApiUtils.makeAjaxRequest(
    {
      url: "/.api.commerce.emailnotification.json",
      method: ApiUtils.METHOD_POST,
      payload: formData,
    },
    (res) => {
      if (res.status === ApiUtils.RESPONSE_SUCCESS) {
        dispatch({
          type: PDC.NOTIFY_USER_FORM_SUCCESS,
          payload: { ...res, pid: formData.pid },
        })
      } else {
        dispatch({
          type: PDC.NOTIFY_USER_FORM_FAILURE,
          payload: { ...res, pid: formData.pid },
        })
      }
    },
    (err) => {
      dispatch({
        type: PDC.NOTIFY_USER_FORM_FAILURE,
        payload: err,
      })
    }
  )
}

export const updateNotifyStatus = (productId) => (dispatch) => {
  dispatch({
    type: PDC.NOTIFY_USER_FORM,
    payload: { pid: productId },
  })
}
